import { render, staticRenderFns } from "./DatabaseSizeTracker.vue?vue&type=template&id=044c0ac2&scoped=true&"
import script from "./DatabaseSizeTracker.vue?vue&type=script&lang=js&"
export * from "./DatabaseSizeTracker.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseSizeTracker.vue?vue&type=style&index=0&id=044c0ac2&lang=scss&scoped=true&"
import style1 from "./DatabaseSizeTracker.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c0ac2",
  null
  
)

export default component.exports